import clsx from 'clsx';

/** Heading levels a sub-section title may take, below the section's own `h1`. */
export type SubHeadingLevel = 'h2' | 'h3';

interface AnalysisSubHeaderProps {
  title: string;
  subtitle?: string;
  /**
   * Both tones are 14px and differ only in colour and leading. Narrative sections
   * (Executive Summary, Company Information) sit in `foreground-subtle` on a 24px
   * line; the rest use `foreground-alt` on the tighter body leading.
   */
  subtitleTone?: 'body' | 'meta';
  /**
   * Heading level for the title. `h2` for a sub-section directly under the section
   * heading; `h3` where it sits inside an already-titled block.
   */
  headingLevel?: SubHeadingLevel;
}

/**
 * Title + subtitle heading for a sub-section within an IQ analysis section
 * (Executive Summary, Company Information, ...). Distinct from `SubSectionHeader`,
 * which prepends an icon tile; use that where the design calls for the icon.
 */
export const AnalysisSubHeader = ({
  title,
  subtitle,
  subtitleTone = 'body',
  headingLevel: Heading = 'h2',
}: AnalysisSubHeaderProps) => (
  <div className="flex flex-col">
    <Heading className="text-heading-lg font-medium text-foreground">{title}</Heading>
    {subtitle && (
      <span
        className={clsx(
          subtitleTone === 'meta'
            ? 'text-body-md text-foreground-alt'
            : 'text-label-md leading-6 text-foreground-subtle',
        )}
      >
        {subtitle}
      </span>
    )}
  </div>
);
